const SMPQuestDefaultStrategy = require("@/quest-editor/questImpl/strategies/SMPQuestDefaultStrategy");
class SMPQuestMakeNComboHitStrategy extends SMPQuestDefaultStrategy {

     initStartingValue() {
          this._challengeList = [6, 9, 15, 25, 40, 60, 90];
     }

     increaseKPIGameplayReference() {
          this.questContext.KPIGameplayBossLevel += this.questContext.JumpingLevel;
     }

     computeChallenge() {
          this.questContext.challengeTarget = this.getTargetBaseOnLevel(this.questContext.level);
     }

     computeLevelShouldAppear() {
          let shouldAppearAt = Math.ceil(this.questContext.challengeTarget / 9.0) - 1;
          shouldAppearAt = this.questContext.KPIGameplayBossLevel - shouldAppearAt;
          if (shouldAppearAt < 1) shouldAppearAt = 1;
          this.questContext.KPIGameLevelShouldAppear = shouldAppearAt;
     }
}

module.exports = SMPQuestMakeNComboHitStrategy;